import { render, staticRenderFns } from "./openManage.vue?vue&type=template&id=3f04392f&scoped=true&"
import script from "./openManage.vue?vue&type=script&lang=ts&"
export * from "./openManage.vue?vue&type=script&lang=ts&"
import style0 from "./openManage.vue?vue&type=style&index=0&id=3f04392f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04392f",
  null
  
)

export default component.exports